<template>
  <v-list-item dense :class="isDisabled ? 'notifDisabled' : 'notifEnabled'">
    <ListItemAvatar :user-id="notification.cause.userId" />
    <v-list-item-content class="notifContent" @click="clicked">
      <v-list-item-title>
        <div class="notifTitle">
          <slot />
        </div>
      </v-list-item-title>
      <v-list-item-subtitle>
        <div class="activeColored">
          {{ fromNow(notification.metadata.timestamp) }}
        </div>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn icon class="activeColored" @click="markSilenced" :disabled="isDisabled">
        <v-icon class="activeColored">
          done
        </v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>
<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import { types as notificationsTypes } from '../../store/notifications';
import ListItemAvatar from '../avatar/ListItemAvatar';

const baseNoosUrl = process.env.VUE_APP_ROOT_URL;

export default {
  name: 'AnalysisNotification',
  components: {
    ListItemAvatar,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isDisabled() {
      return !(this.notification.metadata.status === 'created' || this.notification.metadata.status === 'displayed');
    },
  },
  methods: {
    ...mapActions({
      markNotificationAsSilenced: notificationsTypes.actions.markNotificationAsSilenced,
      markNotificationAsClicked: notificationsTypes.actions.markNotificationAsClicked,
    }),
    markSilenced() {
      this.markNotificationAsSilenced({ notificationId: this.notification.id });
    },
    clicked() {
      this.markNotificationAsClicked({ notificationId: this.notification.id });
      if (this.notification.type === 'analysis') {
        window.open(this.analysisLink(this.notification), '_blank');
      }
      if (this.notification.type === 'mission') {
        window.open(this.analysisLink(this.notification), '_blank');
      }
    },
    analysisLink(notification) {
      const baseUrl = `${baseNoosUrl}/redirect`;
      const targetUrl = new URL(baseUrl);

      targetUrl.searchParams.append('redirectUrl', notification.details.documentUrl);
      targetUrl.searchParams.append('analysisId', notification.details.analysisId);

      return targetUrl.href;
    },
    fromNow(timestamp) {
      return moment(timestamp).fromNow();
    },
  },
};
</script>
<style>
.notifTitle {
  -webkit-line-clamp: 2;
  white-space: normal;
  max-height: 38px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 18px;
  color: #333;
}

.notifEnabled .activeColored, .notifEnabled .activeColored .activeColored {
  color: #5d5fef;
}
.notifDisabled, .notifDisabled .notifTitle, .notifDisabled .activeColored, .notifDisabled .activeColored .activeColored {
  color: #bbb;
}

.notifDisabled {
  background-color: #f0f0f0;
}
.notifContent {
  cursor: pointer;
}

.notificationAvatar {
  color: white;
  font-weight: 500;
}
</style>
